import palette from "../palette";

export default {
  root: {
    "&$disabled": {
      color: palette.action.disabled,
    },
  },
};
